// InPlants.tsx - умный родитель
import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";

import { useContext } from "react";
import { Context } from "../../../index";
import Lines from "../components/Lines/Lines";
import Station from "../components/Station/Station";
import Modules from "../components/Modules/Modules";

export default observer(function InPlants() {
  const { store, inplantsStore } = useContext(Context);

  // Инициализация inplantsStore при выборе завода
  useEffect(() => {
    if (store.plant && store.plant.id) {
      inplantsStore.initialize(store.plant);
      inplantsStore.loadPlantData(store.plant.id);
    }
  }, [store.plant?.id]);

  // Авто-рефреш
  useEffect(() => {
    const isDev = inplantsStore.isDev;
    const plantId = inplantsStore.plant?.id;
    const hasActiveModule = inplantsStore.activeModule?.id;

    if (plantId && !hasActiveModule && !isDev && inplantsStore.isPoll) {
      inplantsStore.startAutoRefresh(plantId, 3000);
    }

    return () => {
      inplantsStore.stopAutoRefresh();
    };
  }, [
    inplantsStore.plant?.id,
    inplantsStore.activeModule?.id,
    inplantsStore.isDev,
    inplantsStore.isPoll,
  ]);

  return (
    <div className="inplants">
      <Lines />
      <Modules />
      <Station />
    </div>
  );
});
